
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications-week/[slug]",
      function () {
        return require("private-next-pages/applications-week/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applications-week/[slug]"])
      });
    }
  